import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
);

function NotFound() {
    return (
        <div className="home">
            <header className="home-header">
                <img src="/logos/seriea.png" alt="Serie A Logo" />
                <h1>404</h1>
                <p>Pagina non trovata. Il link che hai seguito potrebbe essere errato o la pagina non esiste.</p>
            </header>
            <main className="home-grid">
                <Link to="/" className="home-card">
                    <div className="home-card-icon"><NotFoundIcon /></div>
                    <h2>Torna alla Home</h2>
                    <p>Ritorna alla pagina principale per scegliere la modalità di asta.</p>
                </Link>
            </main>
        </div>
    );
}

export default NotFound;
